import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const addUserToOrganizationMutationAtom = createMutationAtomFactory(
  'admin.addUserToOrganization',
  (params: { organizationId: string; userId: string }) => ({
    coreOrganizationAddUser: {
      __args: {
        organizationId: params.organizationId,
        userId: params.userId,
      },
    },
  }),
);

export const removeUserFromOrganizationMutationAtom = createMutationAtomFactory(
  'admin.removeUserFromOrganization',
  (params: { organizationId: string; userId: string }) => ({
    coreOrganizationRemoveUser: {
      __args: {
        organizationId: params.organizationId,
        userId: params.userId,
      },
    },
  }),
);
